import { render, staticRenderFns } from "./TransactionCard.vue?vue&type=template&id=89b1d0fe"
import script from "./TransactionCard.vue?vue&type=script&lang=js"
export * from "./TransactionCard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports